import React, { useState } from 'react';

function ArticleActions({ article }) {
  const storageKey = `icer:article:${article.id}:liked`;
  const [liked, setLiked] = useState(() => {
    try {
      return localStorage.getItem(storageKey) === 'true';
    } catch {
      return false;
    }
  });
  const [message, setMessage] = useState('');
  const [showCopyLink, setShowCopyLink] = useState(false);
  const articleUrl = new URL(`/article/${encodeURIComponent(article.id)}`, window.location.origin).href;

  const toggleLike = () => {
    const nextLiked = !liked;
    setLiked(nextLiked);
    setMessage('');
    try {
      if (nextLiked) localStorage.setItem(storageKey, 'true');
      else localStorage.removeItem(storageKey);
    } catch {
      setMessage('Таны сонголт энэ хуудсыг хаах хүртэл хадгалагдана.');
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(articleUrl);
      setShowCopyLink(false);
      setMessage('Холбоос хуулагдлаа.');
    } catch {
      setShowCopyLink(true);
      setMessage('Доорх холбоосыг сонгож хуулна уу.');
    }
  };

  const shareArticle = async () => {
    setMessage('');
    try {
      await navigator.share({ title: article.title, url: articleUrl });
    } catch (error) {
      if (error.name !== 'AbortError') {
        setMessage('Хуваалцах боломжгүй байна. Facebook эсвэл холбоос хуулах товчийг ашиглана уу.');
      }
    }
  };

  return (
    <section className="article-actions" aria-label="Нийтлэлд хариу үйлдэл үзүүлэх, хуваалцах">
      <div className="article-actions-row">
        <button type="button" className="article-action-button article-like-button" aria-pressed={liked} onClick={toggleLike}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill={liked ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
            <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z" />
          </svg>
          Таалагдлаа
        </button>
        <div className="article-share-actions">
          <span className="article-share-label">Хуваалцах:</span>
          <a className="article-action-button" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(articleUrl)}`} target="_blank" rel="noopener noreferrer" aria-label="Facebook дээр хуваалцах">
            Facebook <span aria-hidden="true">↗</span>
          </a>
          {typeof navigator.share === 'function' && (
            <button type="button" className="article-action-button" onClick={shareArticle}>Бусад</button>
          )}
          <button type="button" className="article-action-button" onClick={copyLink}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
              <rect x="8" y="8" width="12" height="12" rx="2" />
              <path d="M16 8V4H4v12h4" />
            </svg>
            Холбоос хуулах
          </button>
        </div>
      </div>
      <p className="article-action-status" role="status">{message}</p>
      {showCopyLink && (
        <input className="article-share-url" aria-label="Нийтлэлийн холбоос" value={articleUrl} readOnly onFocus={event => event.target.select()} />
      )}
    </section>
  );
}

export default ArticleActions;
